import {
  createColumnHelper,
  getCoreRowModel,
  getFacetedMinMaxValues,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import PaginatedTable from '../Common/PaginatedTable';
import { HiPencilAlt, HiXCircle } from 'react-icons/hi';
import { Inventory } from '../../Models/Inventory';
import { formatNumbers } from '../../Utils';

export default function InventoryListTable({
  data,
  deleteInventory,
  editInventory,
}: {
  data: Inventory[];
  deleteInventory(id: number): void;
  editInventory: (inv: Inventory) => void;
}) {
  const columnHelper = createColumnHelper<Inventory>();

  const columns = [
    columnHelper.accessor((row) => row.id, {
      id: 'id',
      header: '',
      cell: (info) => (
        <div className='flex justify-center gap-1'>
          <button
            type='button'
            className='buttonMain p-2'
            onClick={() => editInventory(info.row.original)}
          >
            <HiPencilAlt />
          </button>
          <button
            type='button'
            className='buttonCancel p-2'
            onClick={() => deleteInventory(info.getValue())}
          >
            <HiXCircle />
          </button>
        </div>
      ),
      footer: (info) => info.column.id,
      size: 35,
      enableColumnFilter: false,
    }),
    columnHelper.accessor((row) => row.name, {
      id: 'name',
      header: 'Name',
      cell: (info) => (
        <div
          className='cursor-pointer text-blue-600'
          onClick={() => editInventory(info.row.original)}
        >
          {info.getValue()}
        </div>
      ),
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.type?.name, {
      id: 'typeId',
      header: 'Type',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
      filterFn: 'includesString',
    }),
    columnHelper.accessor((row) => row.quantityRemaining, {
      id: 'quantityRemaining',
      header: 'Remaining',
      sortingFn: 'alphanumeric',
      footer: (info) => info.column.id,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    initialState: {
      pagination: {
        pageIndex: 0,
        pageSize: 20,
      },
      sorting: [
        {
          id: 'id',
          desc: false,
        },
      ],
    },
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });

  return (
    <>
      <div className='w-full mx-auto overflow-x-auto'>
        <PaginatedTable
          table={table}
          dataCount={data.length}
          columnResizeMode='onChange'
          showFilters={true}
        />
      </div>
    </>
  );
}
